import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Syllabus = () => {
  useEffect(() => {
    document.title =
      "Syllabus - Mar Gregorios Memorial Hr. Sec. School, Bokaro";
  }, []);
  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academic</li>
          <li>Syllabus</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Syllabus</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-1.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class I</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-2.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class II</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-3.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class III</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-4.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class IV</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-5.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class V</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-6.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class VI</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-7.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class VII</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-8.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class VIII</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-9.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class IX</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-10.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class X</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-11.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class XI</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
            <div className="col-lg-4 col-md-6">
              {" "}
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/pdf/syllabus/Class-12.pdf#toolbar=0"
                target="_blank"
              >
                {" "}
                <div className="sample-blk">
                  {" "}
                  <p>Class XII</p>{" "}
                  <LazyLoad>
                    <img
                      alt="mgm"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>{" "}
                </div>{" "}
              </Link>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Syllabus;
